import React from 'react';
import { func } from 'prop-types';

import { requiredFieldArrayCheckbox } from '../../../util/validators';
import { FieldCheckboxGroup } from '../../../components';

import { FormattedMessage, intlShape } from '../../../util/reactIntl';

import css from './TermsAndConditions.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import routeConfiguration from '../../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';

const TermsAndConditions = props => {
  const { onOpenTermsOfService, onOpenPrivacyPolicy, intl, isCustomer = false } = props;
  const history = useHistory();

  const handleDocumentOpen = (event, onOpen, href) => {
    event.preventDefault();
    event.stopPropagation();

    if (typeof onOpen === 'function') {
      if (event?.currentTarget && typeof event.currentTarget.focus === 'function') {
        event.currentTarget.focus();
      }
      onOpen(event);
      return;
    }

    history.push(href);
  };

  const termsHref = createResourceLocatorString(
    'TermsOfServicePage',
    routeConfiguration(),
    {},
    { tab: isCustomer ? 'consumer' : 'professional' }
  );
  const privacyHref = createResourceLocatorString('PrivacyPolicyPage', routeConfiguration(), {}, {});

  const handleClick = (callback, href) => e => {
    e.preventDefault();
    handleDocumentOpen(e, callback, href);
  };

  const termsLink = (
    <a
      className={css.termsLink}
      href={termsHref}
      data-navigation-intercept="ignore"
      onClick={handleClick(onOpenTermsOfService, termsHref)}
      onMouseDown={event => event.stopPropagation()}
    >
      <FormattedMessage id="AuthenticationPage.termsAndConditionsTermsLinkText" />
    </a>
  );

  const privacyLink = (
    <a
      className={css.termsLink}
      href={privacyHref}
      data-navigation-intercept="ignore"
      onClick={handleClick(onOpenPrivacyPolicy, privacyHref)}
      onMouseDown={event => event.stopPropagation()}
    >
      <FormattedMessage id="AuthenticationPage.termsAndConditionsPrivacyLinkText" />
    </a>
  );

  return (
    <div className={css.root}>
      <FieldCheckboxGroup
        name="terms"
        id="terms-accepted"
        optionLabelClassName={css.finePrint}
        options={[
          {
            key: 'tos',
            label: intl.formatMessage(
              { id: 'AuthenticationPage.termsAndConditionsAcceptText' },
              { termsLink, privacyLink }
            ),
          },
        ]}
        validate={requiredFieldArrayCheckbox(
          intl.formatMessage({ id: 'AuthenticationPage.termsAndConditionsAcceptRequired' })
        )}
      />
      <FieldCheckboxGroup
        name="cookies"
        id="cookies-accepted"
        optionLabelClassName={css.finePrint}
        options={[
          {
            key: 'cookies-and-privacy',
            label: intl.formatMessage(
              { id: 'AuthenticationPage.cookiesAcceptText' },
              { termsLink, privacyLink }
            ),
          },
        ]}
        validate={requiredFieldArrayCheckbox(
          intl.formatMessage({ id: 'AuthenticationPage.cookiesAcceptTextRequired' })
        )}
      />
    </div>
  );
};

TermsAndConditions.propTypes = {
  onOpenTermsOfService: func,
  onOpenPrivacyPolicy: func,
  intl: intlShape.isRequired,
};

export default TermsAndConditions;
